import React from "react";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

import CustomListItem from "../../../../helper-components/misc/CustomListItem";
import { getNavItems } from "../../../../config/constants/Constants.js";
import { useLanguage } from "../../../../config/language/language.js";

export default function Sidebar(props) {
    useLanguage(); // re-render nav labels when language changes
    const isMobile = props.browser.isMobile;
    const openDrawer = props.sidebar.openAppDrawer;
    const toggleDrawer = props.sidebar.toggleAppDrawer;
    const closeSidebarIfMobile = isMobile ? (openDrawer ? toggleDrawer : undefined) : undefined;

    const requiresLogin = props.auth.authStatus?.requiresLogin;
    const isLoggedIn = props.user.isLoggedIn;
    const showLogin = requiresLogin && !isLoggedIn;

    return (
        <List component="nav" onClick={closeSidebarIfMobile}>
            {getNavItems().filter((item) => {
                if (item.adminOnly && !props.roles.isAdmin) return false;
                if (item.guestOnly && !showLogin) return false;
                return true;
            }).map((item) => (
                <CustomListItem
                    key={item.path}
                    {...props}
                    name={item.name}
                    description={item.description}
                    icon={item.icon}
                    path={item.path}
                    enableNavigation
                    enableTooltip
                />
            ))}
            <Divider sx={{ my: 1 }} />
        </List>
    );
}
